import {Workspace} from "../../API";
import {WorkspaceModelSnapshotIn} from "../WorkspaceStore";


import {parseJsonOrFallback} from "./parseJsonOrFallback";


export const workspaceToWorkspaceMSTSnapshotIn = (workspaceServer: Workspace): WorkspaceModelSnapshotIn => {
    const workspaceSnapshotIn: WorkspaceModelSnapshotIn = {
        ...workspaceServer,
        name: workspaceServer.name ?? '',
        slug: workspaceServer.slug ?? '',
        avatarPath: workspaceServer.avatarPath ?? undefined,
        childIds: parseJsonOrFallback(workspaceServer.childIds),
        trashedIds: parseJsonOrFallback(workspaceServer.trashedIds),
        archivedIds: parseJsonOrFallback(workspaceServer.archivedIds),

        items: {},
    };

    return workspaceSnapshotIn;
}
